import { render, staticRenderFns } from "./tables-modal.vue?vue&type=template&id=3d364d1e"
import script from "./tables-modal.vue?vue&type=script&lang=js"
export * from "./tables-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports